<script>
  let subscibeEmail;

  function onSubmitSubscribe() {
    fetch(`https://us-central1-afanjou-7181c.cloudfunctions.net/sendMailSubscribe?dest=${subscibeEmail}`);
    subscibeEmail = '';
    toastr.success('Votre inscription a été transmise avec succès !');
  }
</script>

<footer id="footer">
  <div class="footer-top">
    <div class="container">
      <div class="row">

        <div class="col-lg-4 col-md-6">
          <div class="footer-info" data-aos="fade-up" data-aos-delay="50">
            <h3>AFAnjou</h3>
            <p class="pb-3"><em>À votre service depuis 2012.</em></p>
            <p>
              8330 Boulevard Parkway<br>
              Anjou, QC H1J 1N2<br><br>
              <strong>Téléphone:</strong>+1 (438) 395-7522<br>
              <strong>Courriel:</strong> <a href="mailto:contact@afanjou.ca">contact@afanjou.ca</a><br>
            </p>
<!--            <div class="social-links mt-3">-->
<!--              <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>-->
<!--            </div>-->
          </div>
        </div>

        <div class="col-lg-4 col-md-6 footer-newsletter" data-aos="fade-up" data-aos-delay="350">
          <h4>Notre infolettre</h4>
          <p>Recevez des courriels informatifs à propos du centre et de la communauté à Anjou</p>
          <form action="" method="post">
            <input class="tw-text-black" type="email" name="email" bind:value={subscibeEmail}>
            <input type="submit" value="S'abonner" on:click|preventDefault={onSubmitSubscribe}>
          </form>

        </div>

      </div>
    </div>
  </div>

  <div class="container">
    <div class="copyright">
      &copy; Copyright <strong><span>AFAnjou</span></strong>. Tous droits réservés
    </div>
  </div>
</footer>